import Vue from 'vue'
import {ValidationProvider,ValidationObserver,extend,localize} from 'vee-validate'
import { required, email } from "vee-validate/dist/rules";
import en from 'vee-validate/dist/locale/en.json'
import cn from 'vee-validate/dist/locale/zh_CN.json'
import cht from 'vee-validate/dist/locale/zh_TW.json'
import jp from 'vee-validate/dist/locale/ja.json'

localize({ en, cn, cht,jp});
if(localStorage.getItem('lang')){
    if(localStorage.getItem('lang')==='EN'){
        extend('required',{
            ...required,
            message:'The {_field_} is required'
        })
        extend('email', email)
        localize('en')
    }else if(localStorage.getItem('lang')==='CN'){
        extend('required',{
            ...required,
            message:'{_field_}为必填'
        })
        extend('email', email)
        localize('cn')
    }else if(localStorage.getItem('lang')==='CHT'){
        extend('required',{
            ...required,
            message:'{_field_}為必填'
        })
        extend('email', email)
        localize('cht')
    }else if(localStorage.getItem('lang')==='JP'){
        extend('required',{
            ...required,
            message:'{_field_}は必須項目です'
        })
        extend('email', email)
        localize('jp')
    }
}else{
    extend('required',{
        ...required,
        message:'The {_field_} is required'
    }) 
    extend('email', email)
    localize('en')
}




Vue.component('ValidationProvider',ValidationProvider)
Vue.component('ValidationObserver',ValidationObserver)




// WEBPACK FOOTER //
// ./src/rules/rules.js